import store from '@/store'
import lodash from 'lodash'
import { EventBus } from '@/EventBus.js';

class Ui {
  static setTitle(title) {
    store.commit('SET_PAGE_TITLE', title)
    EventBus.$emit('compute_folded')
  }

  static setTitleName(lead) {
    store.commit('SET_PAGE_TITLE_NAME', lead )
    EventBus.$emit('compute_folded')
  }

  static setBreadcrumbs(breadcrumbs) {
    store.commit('SET_PAGE_BREADCRUMBS', breadcrumbs)    
    EventBus.$emit('compute_folded')

    // Breadcrumbs and subtitle/page level are incompatible
    store.commit('SET_PAGE_SUBTITLE', '')
    store.commit('SET_PAGE_LEVEL', '1')
  }

  static setSubtitle(title) {
    store.commit('SET_PAGE_SUBTITLE', title)
    EventBus.$emit('compute_folded')

    // Breadcrumbs and subtitle/page level are incompatible
    store.commit('SET_PAGE_BREADCRUMBS', [])
  }

  static setPageLevel(level) {
    store.commit('SET_PAGE_LEVEL', level)
    EventBus.$emit('compute_folded')

    // Breadcrumbs and subtitle/page level are incompatible
    store.commit('SET_PAGE_BREADCRUMBS', [])
  }

  static setPageType(level) {
    store.commit('SET_PAGE_TYPE', level)
    EventBus.$emit('compute_folded')
  }

  static setHeaderButtons(buttons) {
    store.commit('SET_HEADER_BUTTONS', buttons)
    EventBus.$emit('compute_folded')
  }

  static clearHeaderButtons() {
    store.commit('SET_HEADER_BUTTONS', null)
  }

  static setSecondaryHeaderTabs(tabs) {
    store.commit('SET_SECONDARY_HEADER_TABS', tabs)
    EventBus.$emit('compute_folded')
  }

  static setPageNumber(page_number) {
    store.commit('SET_CURRENT_PAGE', page_number)
    EventBus.$emit('compute_folded')
  }

  static getLevel() {
    return store.state.page_level
  }

  static getCurrentPageProjects() {
    return store.getters.getCurrentPageProjects
  }

  static getCurrentPageSegments() {
    return store.getters.getCurrentPageSegments
  }

  static getCurrentPageLeads() {
    return store.getters.getCurrentPageLeads
  }

  static getCurrentPageLeadMasks() {
    return store.getters.getCurrentPageLeadMasks
  }

  static getCurrentPageUsers() {
    return store.getters.getCurrentPageUsers
  }

  static getCurrentPageExternalForms() {
    return store.getters.getCurrentPageExternalForms
  }

  static getCurrentPageOrganizations() {
    return store.getters.getCurrentPageOrganizations
  }

  static getCurrentPageEmailTemplates(){
    return store.getters.getCurrentPageEmailTemplates
  }

  static startLoading() {
    let div = document.querySelector('.main-content')
    if (div !== null) {
      div.classList.add('is-loading')
    }
  }

  static finishLoading() {
    let div = document.querySelector('.main-content')
    if (div !== null) {
      div.classList.remove('is-loading')
    }
  }
}

export default Ui



// WEBPACK FOOTER //
// ./src/classes/Ui.js